export const MIN_SURVEY_COMPLETION_DECIMAL = 0.75
export const MIN_SURVEY_COMPLETION = MIN_SURVEY_COMPLETION_DECIMAL * 100
